import http from '@/axios/http'

const fetch = ({ url = '/get_user_event_roles' }) =>
  http
    .get(url)
    .then(response => response.data)

export default fetch
